import {
  CONTAINER_COLLAPSED_CLASS,
  CONTAINER_EXPANDING_CLASS,
  CONTAINER_COLLAPSE_ANIMATION_TIMEOUT_S,
  CONTAINER_ID,
  SESSION_COLLAPSED,
  LOGO_ID,
  LOGO_APPEAR_ANIMATION_TIMEOUT_S,
} from '../constants';
import { MSG_NAME_TO_IFRAME, sendMessageToIframe } from '../handleIframeMessage/handleIframeMessage';

export const applyContainerCollapseStyles = (container: HTMLElement) => {
  container.classList.add(CONTAINER_COLLAPSED_CLASS);

  // Remove animation because Safari continues to apply the last animation frame style instead of inline style
  setTimeout(() => {
    const logo = document.getElementById(LOGO_ID);
    if (logo) {
      try {
        const UA = window.sessionStorage.getItem('ABTastyUA');
        const isSafari = UA && JSON.parse(UA).browser.name === 'Safari';
        if (isSafari) logo.style.animation = 'none';
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        // Ignore error
      }
    }
    sendMessageToIframe({ name: MSG_NAME_TO_IFRAME.QaAssistantCollapse, value: true });
  }, LOGO_APPEAR_ANIMATION_TIMEOUT_S * 2000);
};

export const applyContainerExpandStyles = (container: HTMLElement) => {
  container.classList.remove(CONTAINER_COLLAPSED_CLASS);
  setTimeout(() => {
    container.classList.add(CONTAINER_EXPANDING_CLASS);
  }, 0);
  setTimeout(() => {
    container.classList.remove(CONTAINER_EXPANDING_CLASS);
    sendMessageToIframe({ name: MSG_NAME_TO_IFRAME.QaAssistantCollapse, value: false });
  }, CONTAINER_COLLAPSE_ANIMATION_TIMEOUT_S * 1000);
};

export const collapseQAAssistant = (collapse: boolean) => {
  if (typeof collapse !== 'boolean') return;

  const container = document.getElementById(CONTAINER_ID);
  if (collapse) {
    sessionStorage.setItem(SESSION_COLLAPSED, 'true');
    if (container) applyContainerCollapseStyles(container);
  } else {
    sessionStorage.removeItem(SESSION_COLLAPSED);
    if (container) {
      applyContainerExpandStyles(container);
    }
  }
};
